import {useRepo} from "../../../repos/useRepo";
import React, {useEffect, useMemo, useState} from "react";
import {SalesChannelApplication} from "../../../models/SalesChannelApplication";
import PickerInput, {PickerProps, PickerPropsWithoutOptions} from "../inputs/PickerInput";

export function SalesChannelApplicationPicker(props: PickerProps) {
    return <PickerInput label={'Application'} {...props} />
}
